/* ============================================================
   JT — Kinecore behaviors. Chạy sau au.js (au.js lo cart drawer,
   badge giỏ, chặn icon giỏ Horizon). File này lo phần trang:
   reveal (khối + lệch nhịp từng con), đếm số, vòng %, header, menu mobile, gallery PDP, variant,
   bundle, sticky ATC, accordion, carousel review, sort collection.
   Mọi hàm đều idempotent (guard data-jt-wired) để gọi lại an toàn
   khi Horizon morph DOM / theme editor reload section.
   ============================================================ */
(function () {
  'use strict';
  var REDUCED = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) || /[?&]static=1/.test(location.search);

  function money(cents) {
    if (window.jtFormatMoney) return window.jtFormatMoney(cents);
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var sym = { USD: '$', EUR: '€', GBP: '£', AUD: '$', CAD: '$' }[cur] || '€';
    var v = cents / 100;
    return sym + (v % 1 === 0 ? v.toFixed(2) : v.toFixed(2));
  }

  /* ---------- chuyển động khi cuộn (viết lại 4/9/2026) ----------
     Hai kiểu:
       KHỐI  (.jt-rv + vài selector thêm): như cũ, 26px / 700ms, lệch pha .06s theo section.
       TỪNG CON (danh sách STAGGER, chỉ trong main.jt-pp): mỗi phần tử con của lưới là
         một nhịp riêng cách nhau 75ms — thẻ tính năng, review, vòng tròn, bước, hàng
         bảng so sánh, câu hỏi FAQ… hiện lần lượt thay vì cả lưới nhảy lên một lượt.
     Chạy bằng Web Animations, KHÔNG ghi transition inline (transition inline sống thêm
     một nhịp sau khi hiện xong rồi đè lên transition hover của chính phần tử).
     Khi một phần tử bắt đầu hiện: gắn .jt-in cho nó và cho khối cha → CSS bắn tiếp
     các nhịp nhỏ (tick nhún, kẻ nối vẽ dần, ảnh zoom về 1, gạch chân kéo).
     Chỉ ẩn phần tử đang nằm DƯỚI màn hình lúc chạy (ẩn cả phần đang thấy sẽ chớp);
     phần tử đã thấy vẫn nhận .jt-in ngay để CSS không chờ vô ích.
     Khối .jt-rv bọc một danh sách lệch nhịp thì để yên, tránh con chạy hai lần. */
  var MOTION = !REDUCED;
  if (MOTION && document.documentElement) document.documentElement.classList.add('jt-motion');
  var STAGGER = ['.jt-eff-grid', '.jt-r3-grid', '.jt-cir-grid', '.jt-steps-row', '.jt-meet-col', '.jt-tf-grid',
    '.jt-pb > div:first-child', '.jt-cmp', '.jt-faq-list', '.jt-rg-col', '.jt-feat-tx', '.jt-value-grid', '.jt-grid', '.jt-rev-list',
    '.hm-comfort-grid', '.hm-rev-track', '.hm-ticks', '.hm-spot-tx', '.hm3-side', '.hm3-band-icons', '.ms-bar-row', '.ms-picks-track', '.ms-rev-grid', '.ms-ugc-track', '.ms-ig-grid'];
  var BLOCKS = ['.jt-rv', '.jt-lx > .jt-wrap', '.jt-rg-im', '.jt-meet-img', '.jt-swipe-hint', '.jt-ugc-hint', '.jt-steps-note', '.jt-cir-note'];
  function wireReveal() {
    if (!MOTION || !('IntersectionObserver' in window) || !document.body || !document.body.animate) return;
    if (!wireReveal.io) {
      wireReveal.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          wireReveal.io.unobserve(en.target);
          /* dải cuộn ngang (mobile): theo dõi DẢI, dải vào là cả đàn con hiện lệch nhịp —
             theo dõi từng con thì thẻ nằm ngoài mép phải chỉ hiện khi vuốt tới, trông như lỗi tải */
          if (en.target.jtKids) { en.target.classList.add('jt-in'); en.target.jtKids.forEach(show); return; }
          show(en.target);
        });
        function show(el) {
          el.classList.add('jt-in');
          if (el.jtHost) el.jtHost.classList.add('jt-in');
          var anim = el.animate(
            [{ opacity: 0, transform: el.jtFrom || 'translateY(26px)' }, { opacity: 1, transform: 'none' }],
            { duration: el.jtHost ? 640 : 700, delay: (el.jtDelay || 0) * 1000, easing: 'cubic-bezier(.3,1,.3,1)', fill: 'both' }
          );
          /* fill both: khung đầu giữ suốt lúc chờ delay, khung cuối giữ sau khi chạy xong.
             Phải gỡ opacity/transform inline TRƯỚC rồi mới cancel, làm ngược lại sẽ hụt
             một khung: animation hết tác dụng mà inline opacity:0 còn đó, phần tử chớp tắt. */
          anim.onfinish = function () {
            el.style.removeProperty('opacity');
            el.style.removeProperty('transform');
            anim.cancel();
          };
        }
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    var vh = window.innerHeight, pc = window.innerWidth >= 900;
    var hosts = [], counts = [];
    function prep(el, host, idx) {
      var r = el.getBoundingClientRect();
      /* display:none theo breakpoint, hoặc đang trong tầm nhìn: không ẩn, gắn .jt-in luôn */
      if ((r.width === 0 && r.height === 0) || r.top < vh * 0.9) {
        el.classList.add('jt-in');
        if (host) host.classList.add('jt-in');
        return;
      }
      var from = 'translateY(26px)';
      if (host && pc && host.classList.contains('jt-meet-col')) {
        from = host.classList.contains('jt-meet-col--l') ? 'translateX(-32px)' : 'translateX(32px)';
      }
      if (host) {
        el.jtDelay = Math.min(idx, 9) * 0.075;
      } else {
        var h = el.closest('section, .jt-sec, .jt-wrap') || el.parentElement;
        var k = hosts.indexOf(h);
        if (k < 0) { hosts.push(h); counts.push(0); k = hosts.length - 1; }
        counts[k] += 1;
        el.jtDelay = ((counts[k] - 1) % 6) * 0.06;
      }
      el.jtFrom = from;
      el.jtHost = host || null;
      el.style.opacity = '0';
      el.style.transform = from;
      if (host && host.jtKids) host.jtKids.push(el);
      else wireReveal.io.observe(el);
    }
    function isCarousel(host) {
      var ox = getComputedStyle(host).overflowX;
      return (ox === 'auto' || ox === 'scroll') && host.scrollWidth > host.clientWidth + 4;
    }
    var stagSel = STAGGER.join(',');
    /* 1) lệch nhịp từng con — chỉ trên trang sản phẩm / danh mục */
    var pp = document.querySelector('main.jt-pp, main.jt-hm');
    if (pp) {
      pp.querySelectorAll(stagSel).forEach(function (host) {
        if (host.jtRv) return;
        host.jtRv = true;
        var n = 0;
        if (isCarousel(host)) host.jtKids = [];
        Array.prototype.forEach.call(host.children, function (kid) {
          if (kid.jtRv || /^(SCRIPT|STYLE|TEMPLATE|LINK)$/.test(kid.tagName)) return;
          kid.jtRv = true;
          prep(kid, host, n++);
        });
        if (host.jtKids) { if (host.jtKids.length) wireReveal.io.observe(host); else host.jtKids = null; }
      });
    }
    /* 2) khối */
    document.querySelectorAll(BLOCKS.join(',')).forEach(function (el) {
      if (el.jtRv) return;
      el.jtRv = true;
      if (pp && el.querySelector(stagSel)) { el.classList.add('jt-in'); return; }
      prep(el, null, 0);
    });
  }

  /* ---------- vòng %: số đếm lên cùng nhịp với nét vẽ (jt-rings, 1.1s ease-out) ---------- */
  function wireRings() {
    var els = document.querySelectorAll('[data-jt-ring] > b:not([data-jt-wired])');
    if (!els.length) return;
    function run(b) {
      var target = parseFloat(b.parentElement.getAttribute('data-jt-ring')) || 0;
      var suffix = b.getAttribute('data-jt-suffix') || '';
      var t0 = null, dur = 1100;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        p = 1 - Math.pow(1 - p, 3);
        b.textContent = Math.round(target * p) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!MOTION || !('IntersectionObserver' in window)) { els.forEach(function (b) { b.setAttribute('data-jt-wired', '1'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: .4 });
    els.forEach(function (b) {
      b.setAttribute('data-jt-wired', '1');
      var m = (b.textContent || '').match(/[^\d.,\s]+\s*$/);
      b.setAttribute('data-jt-suffix', m ? m[0] : '%');
      b.textContent = '0' + b.getAttribute('data-jt-suffix');
      io.observe(b);
    });
  }

  /* ---------- accordion <details> trong buy box v2: mở/đóng CAO DẦN thay vì bật tức thì ----------
     <details> gốc mở là cột mua cao thêm một cục, gallery đang dính (sticky) bị đẩy xuống
     một nhịp. Ở đây chặn click summary, gắn open rồi chạy height bằng Web Animations
     (chiều cao summary → summary + body, 340ms), layout đổi từng khung nên gallery
     bên cạnh trôi theo mượt. Reduced motion thì để <details> chạy như gốc. */
  function wireKbAcc() {
    if (!MOTION || !document.body || !document.body.animate) return;
    document.querySelectorAll('.kb-acc details:not([data-jt-wired])').forEach(function (d) {
      d.setAttribute('data-jt-wired', '1');
      var sum = d.querySelector('summary'), body = d.querySelector('.kb-acc-body');
      if (!sum || !body) return;
      var anim = null;
      function finish(open) {
        d.open = open;
        d.style.removeProperty('height');
        d.style.removeProperty('overflow');
        anim = null;
      }
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (anim) { anim.cancel(); anim = null; }
        var ease = 'cubic-bezier(.3,1,.3,1)';
        d.style.overflow = 'hidden';
        if (d.open) {
          var h0 = d.offsetHeight, h1 = sum.offsetHeight;
          d.style.height = h0 + 'px';
          anim = d.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: 300, easing: ease, fill: 'forwards' });
          anim.onfinish = function () { finish(false); };
          anim.oncancel = function () { anim = null; };
        } else {
          var s0 = d.offsetHeight;
          d.style.height = s0 + 'px';
          d.open = true;
          var s1 = sum.offsetHeight + body.offsetHeight;
          anim = d.animate([{ height: s0 + 'px' }, { height: s1 + 'px' }], { duration: 340, easing: ease, fill: 'forwards' });
          anim.onfinish = function () { finish(true); };
          anim.oncancel = function () { anim = null; };
        }
      });
    });
  }

  /* ---------- phản hồi nút mua + giá đổi (buy box v2 và bản cũ) ----------
     Section tự đổi chữ nút ("Adding…" / "Added to cart") và số giá; ở đây chỉ NGHE
     DOM đổi rồi gắn class để CSS vẽ spinner / tick / giá nhún. Không đụng logic mua. */
  function wireKbFeedback() {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('[data-kb-atc], [data-jt-atc]').forEach(function (btn) {
      if (btn.jtFb) return;
      btn.jtFb = true;
      var adding = (btn.getAttribute('data-kb-adding') || btn.getAttribute('data-jt-adding') || 'Adding…').trim();
      var added = (btn.getAttribute('data-kb-added') || btn.getAttribute('data-jt-added') || 'Added').trim();
      var txt = btn.querySelector('[data-kb-atc-txt], .dw-btntxt') || btn;
      function upd() {
        var t = (txt.textContent || '').trim();
        btn.classList.toggle('is-adding', t === adding);
        btn.classList.toggle('is-added', t === added);
      }
      new MutationObserver(upd).observe(txt, { childList: true, characterData: true, subtree: true });
    });
    document.querySelectorAll('[data-kb-atc-price], [data-kb-kit-price], [data-kb-sticky-title], [data-kb-price], [data-jt-price], [data-jt-sticky-price]').forEach(function (el) {
      if (el.jtFb) return;
      el.jtFb = true;
      var last = el.textContent;
      new MutationObserver(function () {
        if (el.textContent === last) return;
        last = el.textContent;
        if (!MOTION) return;
        el.classList.remove('jt-price-tick');
        void el.offsetWidth; /* ép reflow để animation chạy lại từ đầu */
        el.classList.add('jt-price-tick');
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- nút chính hút nhẹ theo con trỏ ---------- */
  function wireMagnet() {
    if (REDUCED) return;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('.jt-btn').forEach(function (btn) {
      if (btn.jtMag) return;
      btn.jtMag = true;
      /* CHỈ ghi hai biến CSS, transform để CSS của nút tự đọc. Ghi thẳng style.transition
         mỗi lần chuột nhích thì trình duyệt phải dựng lại transition liên tục, nút giật. */
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        btn.style.setProperty('--jt-magx', (((e.clientX - r.left) / r.width - 0.5) * 10).toFixed(1) + 'px');
        btn.style.setProperty('--jt-magy', (((e.clientY - r.top) / r.height - 0.5) * 10).toFixed(1) + 'px');
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.setProperty('--jt-magx', '0px');
        btn.style.setProperty('--jt-magy', '0px');
      });
    });
  }

  /* ---------- đếm số tăng dần ---------- */
  function wireCounters() {
    var els = document.querySelectorAll('[data-jt-count]:not([data-jt-wired])');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-jt-count')) || 0;
      var suffix = el.getAttribute('data-jt-suffix') || '';
      if (REDUCED) { el.textContent = target + suffix; return; }
      var t0 = null, dur = 1100;
      function step(ts) {
        if (!t0) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        p = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * p) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (REDUCED || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.setAttribute('data-jt-wired', '1'); run(el); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: .4 });
    els.forEach(function (el) { el.setAttribute('data-jt-wired', '1'); io.observe(el); });
  }

  /* ---------- header: góc lõm + bóng khi cuộn, mobile trượt lên khi cuộn xuống ----------
     Horizon cuộn trong .page-wrapper trên desktop và cuộn window trên mobile, nên phải
     nghe cả hai (và nghe ở pha capture để bắt được scroll của phần tử con).
     Công thức ẩn header đúng bản dreamwood:
       y > đáy header + 100 && đang cuộn xuống  -> html.jt-hdr-hidden
       cuộn lên, hoặc chưa quá ngưỡng            -> bỏ class
     Ngưỡng đo lúc đầu trang; ±4px bỏ qua để ảnh lazy-load co giãn không gây nhiễu. */
  function wireHeader() {
    var hd = document.querySelector('.jt-hd');
    if (!hd || wireHeader.wired) return;
    wireHeader.wired = true;
    var root = document.documentElement;
    var pw = document.querySelector('.page-wrapper');
    var lastY = 0, hdBottom = 0;
    function scrollY() { return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0); }
    function setBottom(el) {
      var b = Math.max(el.getBoundingClientRect().bottom, 0);
      root.style.setProperty('--jt-hd-bottom', Math.round(b) + 'px');
    }
    function measure() {
      var el = document.querySelector('.jt-hd');
      if (!el) return;
      pw = pw || document.querySelector('.page-wrapper');
      hdBottom = Math.round(el.getBoundingClientRect().bottom + scrollY());
      setBottom(el);
    }
    function upd() {
      var el = document.querySelector('.jt-hd');
      if (!el) return;
      var y = scrollY();
      root.classList.toggle('jt-scrolled', y > 40);
      if (!hdBottom) measure();
      /* menu đang mở thì giữ nguyên header: sheet bám đáy header, ẩn header là sheet nhảy */
      if (root.classList.contains('jt-menu-open')) {
        root.classList.remove('jt-hdr-hidden');
        setBottom(el);
        lastY = y;
        return;
      }
      /* Ẩn NGAY từ nhịp cuộn xuống đầu tiên (ngưỡng 10px chỉ để tránh rung khi trang
         mới tải), không chờ cuộn hết chiều cao header nữa: kéo xuống là ảnh hiện ra liền.
         hdBottom vẫn đo để mép trên sheet menu bám đúng đáy header. */
      if (y > 10) {
        if (Math.abs(y - lastY) > 2) root.classList.toggle('jt-hdr-hidden', y > lastY);
      } else {
        root.classList.remove('jt-hdr-hidden');
      }
      if (!root.classList.contains('jt-hdr-hidden')) setBottom(el);
      lastY = y;
    }
    window.addEventListener('scroll', upd, { passive: true });
    if (pw) pw.addEventListener('scroll', upd, { passive: true });
    document.addEventListener('scroll', upd, { passive: true, capture: true });
    window.addEventListener('resize', measure);
    measure(); upd();
    setTimeout(measure, 700);
  }

  /* ---------- menu mobile ---------- */
  function wireMnav() {
    var nav = document.getElementById('jt-mnav');
    var btn = document.querySelector('[data-jt-mnav-open]');
    if (!nav || !btn || btn.hasAttribute('data-jt-wired')) return;
    btn.setAttribute('data-jt-wired', '1');
    /* chân sheet (ngôn ngữ + đăng nhập + mạng xã hội) khai một chỗ ở section announce,
       nhân bản sang đây để không phải điền link mạng xã hội hai lần */
    var tpl = document.querySelector('[data-jt-mfoot]');
    var foot = nav.querySelector('.jt-mnav-foot');
    if (tpl && foot && !foot.querySelector('.jt-mnav-bar')) foot.appendChild(tpl.content.cloneNode(true));
    var root = document.documentElement;
    var panel = nav.querySelector('[data-jt-mnav-panel]');
    function open() {
      /* mép trên sheet đặt đúng chỗ thẻ header đang đứng: sheet thay hẳn header.
         Cuộn xuống rồi mở thì header sát mép trên nên sheet phủ kín màn hình. */
      var hd = document.querySelector('.jt-hd');
      var top = hd ? Math.max(hd.getBoundingClientRect().top, 0) : 0;
      root.style.setProperty('--jt-mnav-top', Math.round(top) + 'px');
      nav.classList.add('open');
      nav.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
      root.classList.add('jt-menu-open');
      root.style.overflow = 'hidden';
    }
    function close() {
      nav.classList.remove('open');
      nav.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
      root.classList.remove('jt-menu-open');
      root.style.overflow = '';
    }
    btn.addEventListener('click', function () { nav.classList.contains('open') ? close() : open(); });
    nav.querySelectorAll('[data-jt-mnav-close]').forEach(function (b) { b.addEventListener('click', close); });
    /* vuốt tay nắm xuống để đóng, kéo chưa đủ 70px thì sheet bật về chỗ cũ */
    var grab = nav.querySelector('[data-jt-mnav-grab]');
    if (grab && panel && window.PointerEvent) {
      var y0 = null, dy = 0;
      grab.addEventListener('pointerdown', function (e) {
        y0 = e.clientY; dy = 0;
        panel.style.transition = 'none';
        grab.setPointerCapture(e.pointerId);
      });
      grab.addEventListener('pointermove', function (e) {
        if (y0 == null) return;
        dy = Math.max(e.clientY - y0, 0);
        panel.style.transform = 'translateY(' + dy + 'px)';
      });
      function drop() {
        if (y0 == null) return;
        y0 = null;
        panel.style.transition = '';
        if (dy > 70) {
          panel.style.transform = 'translateY(100%)';
          close();
          setTimeout(function () { panel.style.transform = ''; }, 420);
        } else {
          panel.style.transform = '';
        }
      }
      grab.addEventListener('pointerup', drop);
      grab.addEventListener('pointercancel', drop);
      grab.addEventListener('click', function () { if (dy <= 70) close(); });
    }
    nav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- accordion chung (FAQ, footer, buybox) ---------- */
  function wireAcc() {
    document.querySelectorAll('[data-jt-acc]:not([data-jt-wired])').forEach(function (btn) {
      btn.setAttribute('data-jt-wired', '1');
      btn.addEventListener('click', function () {
        var it = btn.closest('[data-jt-acc-item]');
        if (!it) return;
        var group = it.getAttribute('data-jt-acc-group');
        var willOpen = !it.classList.contains('open');
        if (group && willOpen) {
          document.querySelectorAll('[data-jt-acc-item][data-jt-acc-group="' + group + '"].open').forEach(function (o) {
            if (o !== it) o.classList.remove('open');
          });
        }
        it.classList.toggle('open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  /* ---------- carousel quotes: chấm trang ---------- */
  function wireQuotes() {
    document.querySelectorAll('[data-jt-quotes]:not([data-jt-wired])').forEach(function (sec) {
      sec.setAttribute('data-jt-wired', '1');
      var track = sec.querySelector('.jt-qtrack');
      var dotsBox = sec.querySelector('.jt-qdots');
      if (!track || !dotsBox) return;
      var cards = track.querySelectorAll('.jt-qcard');
      if (cards.length < 2) { dotsBox.style.display = 'none'; return; }
      dotsBox.innerHTML = '';
      cards.forEach(function (c, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', 'Review ' + (i + 1));
        d.addEventListener('click', function () {
          track.scrollTo({ left: c.offsetLeft - track.offsetLeft, behavior: REDUCED ? 'auto' : 'smooth' });
        });
        dotsBox.appendChild(d);
      });
      var dots = dotsBox.querySelectorAll('button');
      function upd() {
        var x = track.scrollLeft + track.clientWidth / 2;
        var idx = 0;
        cards.forEach(function (c, i) { if (c.offsetLeft - track.offsetLeft < x) idx = i; });
        dots.forEach(function (d, i) { d.classList.toggle('on', i === idx); });
      }
      track.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }

  /* ---------- collection: sort ---------- */
  function wireSort() {
    document.querySelectorAll('[data-jt-sort]:not([data-jt-wired])').forEach(function (sel) {
      sel.setAttribute('data-jt-wired', '1');
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- PDP: gallery ---------- */
  /* ---------- gallery PDP: lúc khoá cuộn thì khoảng trắng trên = dưới ----------
     Ảnh chính vuông nên chiều cao đi theo bề ngang. Hai bước:
       1) --jt-gal-cap giới hạn bề ngang để cả khối (ảnh + dải thumb) lọt trong màn hình,
          chừa tối thiểu 24px mỗi đầu — màn thấp thì ảnh tự nhỏ lại thay vì bị cắt.
       2) --jt-gal-top = (cao màn hình − cao khối) / 2, chính là mép trên lúc sticky.
     Đo lại sau khi đặt cap (đổi cap là đổi chiều cao), và đo lại khi resize. */
  function wireGalFit() {
    var gal = document.querySelector('.jt-gal');
    if (!gal || wireGalFit.wired) return;
    wireGalFit.wired = true;
    function fit() {
      var layoutSection = gal.closest('[data-kc-product-layout]');
      if (layoutSection) {
        var grid = gal.closest('.jt-pdp-in');
        var ctrl = gal.querySelector('.jt-gal-ctrl');
        if (window.innerWidth < 900) {
          grid.style.removeProperty('--kc-gallery-width');
          grid.style.removeProperty('--kc-buy-width');
          gal.style.removeProperty('--jt-rail');
          gal.style.removeProperty('--jt-gal-cap');
          gal.style.removeProperty('--jt-gal-top');
          if (ctrl) ctrl.style.removeProperty('height');
          return;
        }
        var main = gal.querySelector('.jt-gal-main');
        var viewport = window.innerHeight;
        var modernBuybox = layoutSection.classList.contains('kb-pdp');
        var gap = modernBuybox && window.innerWidth < 1200 ? 36 : 56;
        var railGap = window.innerWidth < 1700 ? 14 : 16;
        var oldThumbGap = window.innerWidth < 1700 ? 10 : 12;
        var naturalWidth = (grid.clientWidth - gap) * (modernBuybox && window.innerWidth < 1200 ? 0.5 : 1.32 / 2.32);
        var oldCap = (6 * (viewport - 48) + 5 * railGap - 4 * oldThumbGap) / 5;
        var oldWidth = Math.min(naturalWidth, oldCap);
        var oldRail = Math.max(56, Math.round((oldWidth - railGap - 4 * oldThumbGap) / 6));
        var imageWidth = Math.min(naturalWidth, Math.max(360, Math.round(oldWidth))) - railGap - oldRail;
        var visibleCount = imageWidth >= 700 ? 7 : 6;
        var thumbWidth = Math.floor((imageWidth - (visibleCount - 1) * 10) / visibleCount);
        var galleryWidth = imageWidth + railGap + thumbWidth;
        grid.style.setProperty('--kc-gallery-width', galleryWidth + 'px');
        var buyboxCap = modernBuybox ? 600 : Math.max(600, grid.clientWidth - gap - naturalWidth + oldRail - thumbWidth);
        grid.style.setProperty('--kc-buy-width', Math.min(buyboxCap, grid.clientWidth - gap - galleryWidth) + 'px');
        gal.style.setProperty('--jt-gal-cap', galleryWidth + 'px');
        gal.style.setProperty('--jt-rail', thumbWidth + 'px');
        if (ctrl) ctrl.style.height = imageWidth + 'px';
        requestAnimationFrame(function () {
          if (window.innerWidth < 900) return;
          if (ctrl && main) ctrl.style.height = main.getBoundingClientRect().height + 'px';
          gal.style.top = Math.max(12, (window.innerHeight - gal.offsetHeight) / 2) + 'px';
        });
        return;
      }
      if (window.innerWidth < 900) {
        gal.style.removeProperty('--jt-gal-top');
        gal.style.removeProperty('--jt-gal-cap');
        return;
      }
      var main = gal.querySelector('.jt-gal-main');
      gal.style.removeProperty('--jt-gal-cap');
      gal.style.removeProperty('--jt-rail');
      var vh = window.innerHeight;
      var cs = getComputedStyle(gal);
      var rail = cs.gridTemplateColumns.indexOf(' ') > 0 && gal.offsetWidth > 0
        && parseFloat(cs.gridTemplateColumns) > 0;
      var G = parseFloat(cs.columnGap) || 0;
      var g = parseFloat(cs.getPropertyValue('--jt-tgap')) || 12;
      var N = 5;   // số ảnh nhỏ đúng bằng chiều cao ảnh chính
      if (rail) {
        /* Dải DỌC. Ảnh vuông cạnh R, 5 cái dính liền = ảnh chính:
             5R + 4g = H  và  W = R + G + H   =>  R = (W − G − 4g) / 6
           Muốn H ≤ vh − 48 thì W ≤ (6(vh−48) + 5G − 4g) / 5. */
        var Wnat = gal.offsetWidth;
        var capW = (6 * (vh - 48) + 5 * G - 4 * g) / 5;
        var W = Math.min(Wnat, capW);
        gal.style.setProperty('--jt-gal-cap', Math.max(360, Math.round(W)) + 'px');
        gal.style.setProperty('--jt-rail', Math.max(56, Math.round((W - G - (N - 1) * g) / 6)) + 'px');
      } else {
        /* Dải NGANG (mobile): giới hạn theo phần cao thêm ngoài ảnh. */
        var restV = gal.offsetHeight - (main ? main.offsetHeight : 0);
        gal.style.setProperty('--jt-gal-cap', Math.max(300, Math.round(vh - restV - 48)) + 'px');
      }
      /* đổi --jt-rail xong lưới phải dựng lại rồi chiều cao ảnh mới đúng,
         một khung hình chưa kịp, phải chờ hai khung mới đo */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var ctrl = gal.querySelector('.jt-gal-ctrl');
          if (ctrl) {
            /* Dải phải CAO ĐÚNG BẰNG ảnh chính. Không chốt chiều cao thì hàng lưới
               nở theo số ảnh (6 ảnh là dải thò xuống dưới ảnh) và không bao giờ cuộn. */
            if (rail && main) ctrl.style.height = main.offsetHeight + 'px';
            else ctrl.style.removeProperty('height');
          }
          var gap = Math.round((vh - gal.offsetHeight) / 2);
          gal.style.setProperty('--jt-gal-top', Math.max(gap, 12) + 'px');
        });
      });
    }
    fit();
    var t = null;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); });
    window.addEventListener('load', fit);
  }

  function wireGallery() {
    var gal = document.querySelector('[data-jt-gal]:not([data-jt-wired])');
    if (!gal) return;
    gal.setAttribute('data-jt-wired', '1');
    var track = gal.querySelector('.jt-gal-track');
    var slides = Array.prototype.slice.call(gal.querySelectorAll('.jt-gal-slide'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.jt-thumb'));
    var countEl = gal.querySelector('[data-jt-gal-count]');
    var cur = 0;

    function paint(i, scroll) {
      /* chạy vòng: ở ảnh đầu bấm lùi ra ảnh cuối, ở ảnh cuối bấm tới về ảnh đầu,
         khớp với ô xem lớn vốn đã chạy vòng sẵn */
      var n = slides.length;
      cur = n ? ((i % n) + n) % n : 0;
      thumbs.forEach(function (t, k) {
        var on = k === cur;
        t.classList.toggle('on', on);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (countEl) countEl.textContent = (cur + 1) + ' / ' + slides.length;
      /* trượt sang ô khác thì video đang chạy phải dừng, không thì tiếng vẫn phát */
      slides.forEach(function (sl, k) {
        if (k === cur) return;
        var v = sl.querySelector('video');
        if (v && !v.paused) v.pause();
        var f = sl.querySelector('iframe');
        if (f && f.contentWindow) {
          try { f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); } catch (e) {}
        }
      });
      if (scroll && track && slides[cur]) {
        track.scrollTo({ left: slides[cur].offsetLeft - track.offsetLeft, behavior: REDUCED ? 'auto' : 'smooth' });
      }
      /* kéo ảnh nhỏ đang chọn vào tầm nhìn. Dải dựng dọc (PC) thì cuộn theo trục dọc,
         dải nằm ngang (mobile) thì cuộn ngang như cũ. */
      var onT = thumbs[cur];
      if (onT && onT.parentElement) {
        var tp = onT.parentElement;
        var sm = REDUCED ? 'auto' : 'smooth';
        if (tp.scrollHeight > tp.clientHeight + 1) {
          if (onT.offsetTop < tp.scrollTop) {
            tp.scrollTo({ top: onT.offsetTop, behavior: sm });
          } else if (onT.offsetTop + onT.offsetHeight > tp.scrollTop + tp.clientHeight) {
            tp.scrollTo({ top: onT.offsetTop + onT.offsetHeight - tp.clientHeight, behavior: sm });
          }
        } else if (onT.offsetLeft < tp.scrollLeft || onT.offsetLeft + onT.offsetWidth > tp.scrollLeft + tp.clientWidth) {
          tp.scrollTo({ left: onT.offsetLeft, behavior: sm });
        }
      }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { paint(i, true); }); });
    /* bàn phím: ảnh chính nhận được focus, mũi tên trái phải lật ảnh.
       Gắn ở .jt-gal để focus đang ở ảnh nhỏ hay ở nút mũi tên đều ăn. */
    var mainBox = gal.querySelector('.jt-gal-main');
    if (mainBox && !mainBox.hasAttribute('tabindex')) {
      mainBox.setAttribute('tabindex', '0');
      mainBox.setAttribute('role', 'group');
      mainBox.setAttribute('aria-label', 'Product images');
    }
    gal.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var lbOpen = document.getElementById('jt-lb');
      if (lbOpen && lbOpen.classList.contains('open')) return;
      e.preventDefault();
      paint(cur + (e.key === 'ArrowRight' ? 1 : -1), true);
    });
    gal.querySelectorAll('[data-jt-gal-nav]').forEach(function (b) {
      b.addEventListener('click', function () { paint(cur + parseInt(b.getAttribute('data-jt-gal-nav'), 10), true); });
    });
    if (track) {
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var x = track.scrollLeft + track.clientWidth / 2;
          var idx = 0;
          slides.forEach(function (s, i) { if (s.offsetLeft - track.offsetLeft < x) idx = i; });
          if (idx !== cur) paint(idx, false);
        }, 80);
      }, { passive: true });
    }
    paint(0, false);

    /* lightbox */
    var lb = document.getElementById('jt-lb');
    if (lb) {
      var lbImg = lb.querySelector('img');
      var srcs = slides.map(function (s) { var im = s.querySelector('img'); return im ? (im.getAttribute('data-jt-full') || im.src) : ''; });
      var lcur = 0;
      function lbShow(i) { lcur = (i + srcs.length) % srcs.length; if (lbImg) lbImg.src = srcs[lcur]; }
      slides.forEach(function (s, i) {
        var im = s.querySelector('img');
        if (im) im.addEventListener('click', function () { lbShow(i); lb.classList.add('open'); });
      });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.classList.remove('open'); });
      var lc = lb.querySelector('.jt-lb-close');
      if (lc) lc.addEventListener('click', function () { lb.classList.remove('open'); });
      lb.querySelectorAll('[data-jt-lb-nav]').forEach(function (b) {
        b.addEventListener('click', function () { lbShow(lcur + parseInt(b.getAttribute('data-jt-lb-nav'), 10)); });
      });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('open')) return;
        if (e.key === 'Escape') lb.classList.remove('open');
        if (e.key === 'ArrowRight') lbShow(lcur + 1);
        if (e.key === 'ArrowLeft') lbShow(lcur - 1);
      });
    }
  }

  /* ---------- PDP: variant + bundle + qty + ATC + sticky ---------- */
  function wireBuybox() {
    var box = document.querySelector('[data-jt-buybox]:not([data-jt-wired])');
    if (!box) return;
    box.setAttribute('data-jt-wired', '1');

    var dataEl = box.querySelector('[data-jt-product-json]');
    if (!dataEl) return;
    var P;
    try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var optNames = P.options || [];
    var sel = {};   // bộ chọn chính
    var sel2 = {};  // bộ chọn món #2 khi Buy 2
    optNames.forEach(function (o, i) {
      var first = box.querySelector('.jt-pills[data-jt-opt="' + i + '"] .jt-pill.on') || box.querySelector('.jt-pills[data-jt-opt="' + i + '"] .jt-pill');
      sel[i] = first ? first.getAttribute('data-jt-val') : null;
      sel2[i] = null; // món 2 KẾ THỪA lựa chọn chính tới khi user tự đổi trong picker 2
    });
    // SP chỉ có MỘT phiên bản (Default Title): Liquid không render pill nào nên
    // sel rỗng → findVariant trượt → nút mua tưởng hết hàng. Lấy thẳng variant đầu.
    if (P.variants.length === 1) {
      optNames.forEach(function (_, i) {
        if (sel[i] == null) sel[i] = P.variants[0].options[i];
      });
    }
    // chế độ thẻ bậc (tier cards) thay pill cho option 1
    var tierEls = box.querySelectorAll('[data-jt-tier]');
    if (tierEls.length && sel[0] == null) {
      var tOn = box.querySelector('[data-jt-tier].on') || tierEls[0];
      sel[0] = tOn.getAttribute('data-jt-val');
    }
    function eff2() {
      var s = {};
      optNames.forEach(function (_, i) { s[i] = sel2[i] !== null ? sel2[i] : sel[i]; });
      return s;
    }

    function findVariant(s) {
      return P.variants.find(function (v) {
        return optNames.every(function (_, i) { return v.options[i] === s[i]; });
      });
    }
    function bundleQty() {
      var b2 = box.querySelector('[data-jt-bopt="2"]');
      return (b2 && b2.classList.contains('on')) ? 2 : 1;
    }
    function qtyVal() {
      var q = box.querySelector('[data-jt-qty-input]');
      return q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    }

    function paint() {
      var v = findVariant(sel);
      var v2 = findVariant(eff2());
      var e2 = eff2();
      // pill trạng thái
      optNames.forEach(function (_, i) {
        box.querySelectorAll('.jt-pills[data-jt-opt="' + i + '"] .jt-pill').forEach(function (p) {
          p.classList.toggle('on', p.getAttribute('data-jt-val') === sel[i]);
        });
        box.querySelectorAll('.jt-pills[data-jt-opt2="' + i + '"] .jt-pill').forEach(function (p) {
          p.classList.toggle('on', p.getAttribute('data-jt-val') === e2[i]);
        });
        var valEl = box.querySelector('[data-jt-optval="' + i + '"]');
        if (valEl) valEl.textContent = sel[i] || '';
      });
      tierEls.forEach(function (t) {
        var on = t.getAttribute('data-jt-val') === sel[0];
        t.classList.toggle('on', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      // hàng quà tặng gắn theo bậc: chỉ hiện hàng của bậc đang chọn
      // scope nới ra .jt-pdp để bắt cả ghi chú dưới gallery (nằm ngoài cột mua)
      (box.closest('.jt-pdp') || box).querySelectorAll('[data-jt-gift-for]').forEach(function (g) {
        var show = g.getAttribute('data-jt-gift-for') === sel[0];
        g.hidden = !show;
        g.style.display = show ? '' : 'none';
      });
      // giá
      var isB2 = bundleQty() === 2;
      var unit = v ? v.price : P.price;
      var cmp = v ? v.compare_at_price : null;
      var q = isB2 ? 2 : qtyVal();
      var xsEl = box.querySelector('[data-jt-xsell]');
      var xsExtra = (xsEl && xsEl.checked) ? (parseInt(xsEl.getAttribute('data-jt-xsell-price'), 10) || 0) : 0;
      // ô mua kèm riêng (data-jt-addon) — cộng vào tổng như xsell nhưng độc lập với gói
      var adEl = box.querySelector('[data-jt-addon]');
      var adExtra = (adEl && adEl.checked) ? (parseInt(adEl.getAttribute('data-jt-addon-price'), 10) || 0) : 0;
      var adCmp = (adEl && adEl.checked) ? (parseInt(adEl.getAttribute('data-jt-addon-cmp'), 10) || adExtra) : 0;
      xsExtra += adExtra;
      var total = unit * (isB2 ? 2 : 1) + xsExtra;
      var priceEl = box.querySelector('[data-jt-price]');
      var cmpEl = box.querySelector('[data-jt-compare]');
      if (priceEl) priceEl.textContent = money(unit);
      if (cmpEl) { if (cmp && cmp > unit) { cmpEl.textContent = money(cmp); cmpEl.hidden = false; } else { cmpEl.hidden = true; } }
      var saveEl = box.querySelector('[data-jt-savepill]');
      if (saveEl) {
        if (cmp && cmp > unit) { saveEl.hidden = false; saveEl.textContent = 'Save ' + money(cmp - unit).replace(/\.00$/, ''); }
        else saveEl.hidden = true;
      }
      // bundle giá dòng
      var b1p = box.querySelector('[data-jt-b1-price]'); if (b1p) b1p.innerHTML = money(unit) + (cmp && cmp > unit ? ' <s>' + money(cmp) + '</s>' : '');
      var b2p = box.querySelector('[data-jt-b2-price]'); if (b2p) b2p.innerHTML = money(unit * 2) + (cmp && cmp > unit ? ' <s>' + money(cmp * 2) + '</s>' : '');
      // nút
      var atcs = box.querySelectorAll('[data-jt-atc]');
      var stickyPrice = document.querySelector('[data-jt-sticky-price]');
      var stickySum = document.querySelector('[data-jt-sticky-sum]');
      var available = v && v.available && (!isB2 || (v2 && v2.available));
      atcs.forEach(function (b) {
        b.disabled = !available;
        var lbl = b.querySelector('.dw-btntxt') || b;
        lbl.textContent = available
          ? (b.getAttribute('data-jt-label') || 'Add to cart') + ' — ' + money((isB2 ? unit * 2 : unit * qtyVal()) + xsExtra)
          : (b.getAttribute('data-jt-oos') || 'Sold out');
      });
      // giá gạch sticky: cộng GIÁ GẠCH của món kèm (trước đây cộng giá bán → lệch số với thẻ)
      var xsCmpExtra = ((xsEl && xsEl.checked) ? (parseInt(xsEl.getAttribute('data-jt-xsell-cmp'), 10) || 0) : 0) + adCmp;
      if (stickyPrice) stickyPrice.innerHTML = money(total) + (cmp && cmp > unit ? ' <s style="color:#79828D;font-weight:400">' + money(cmp * (isB2 ? 2 : 1) + xsCmpExtra) + '</s>' : '');
      if (stickySum) {
        var parts = optNames.map(function (_, i) { return sel[i]; }).filter(Boolean);
        stickySum.textContent = parts.join(' · ') + (isB2 ? ' · ×2' : '');
      }
      // qty row ẩn khi buy 2
      var qrow = box.querySelector('[data-jt-qtyrow]');
      if (qrow) qrow.style.display = (isB2 || qrow.hasAttribute('data-jt-qty-off')) ? 'none' : '';
    }

    // pill click
    box.querySelectorAll('.jt-pills[data-jt-opt] .jt-pill').forEach(function (p) {
      p.addEventListener('click', function () {
        var i = parseInt(p.closest('.jt-pills').getAttribute('data-jt-opt'), 10);
        sel[i] = p.getAttribute('data-jt-val');
        paint();
      });
    });
    box.querySelectorAll('.jt-pills[data-jt-opt2] .jt-pill').forEach(function (p) {
      p.addEventListener('click', function () {
        var i = parseInt(p.closest('.jt-pills').getAttribute('data-jt-opt2'), 10);
        sel2[i] = p.getAttribute('data-jt-val');
        paint();
      });
    });
    // thẻ bậc
    tierEls.forEach(function (t) {
      t.addEventListener('click', function () { sel[0] = t.getAttribute('data-jt-val'); paint(); });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel[0] = t.getAttribute('data-jt-val'); paint(); } });
    });
    // bundle chọn
    box.querySelectorAll('[data-jt-bopt]').forEach(function (b) {
      b.addEventListener('click', function () {
        box.querySelectorAll('[data-jt-bopt]').forEach(function (x) { x.classList.toggle('on', x === b); });
        paint();
      });
    });
    // qty stepper
    var qin = box.querySelector('[data-jt-qty-input]');
    box.querySelectorAll('[data-jt-qty-btn]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qin) return;
        qin.value = Math.max(1, (parseInt(qin.value, 10) || 1) + parseInt(b.getAttribute('data-jt-qty-btn'), 10));
        paint();
      });
    });
    if (qin) qin.addEventListener('change', paint);
    var xsChk = box.querySelector('[data-jt-xsell]');
    if (xsChk) xsChk.addEventListener('change', paint);

    // ATC
    function doAdd(btn) {
      var v = findVariant(sel);
      if (!v) return;
      var isB2 = bundleQty() === 2;
      var items = [];
      if (isB2) {
        var v2 = findVariant(eff2()) || v;
        if (v2.id === v.id) items.push({ id: v.id, quantity: 2 });
        else { items.push({ id: v.id, quantity: 1 }); items.push({ id: v2.id, quantity: 1 }); }
      } else {
        items.push({ id: v.id, quantity: qtyVal() });
      }
      var xs = box.querySelector('[data-jt-xsell]');
      if (xs && xs.checked) items.push({ id: Number(xs.getAttribute('data-jt-xsell')), quantity: 1 });
      var ad = box.querySelector('[data-jt-addon]');
      if (ad && ad.checked) items.push({ id: Number(ad.getAttribute('data-jt-addon')), quantity: 1 });
      var lbl = btn.querySelector('.dw-btntxt') || btn;
      var old = lbl.textContent;
      btn.disabled = true;
      lbl.textContent = btn.getAttribute('data-jt-adding') || 'Adding…';
      fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function (json) {
          var keys = [];
          if (json && json.items) json.items.forEach(function (x) { if (x.key) keys.push(x.key); });
          lbl.textContent = btn.getAttribute('data-jt-added') || 'Added ✓';
          setTimeout(function () {
            btn.disabled = false;
            lbl.textContent = old;
            if (typeof window.auOpenDrawer === 'function') window.auOpenDrawer(keys);
            else window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
          }, 420);
        })
        .catch(function () { btn.disabled = false; lbl.textContent = old; window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart'; });
    }
    var addonEl = box.querySelector('[data-jt-addon]');
    if (addonEl) addonEl.addEventListener('change', paint);
    box.querySelectorAll('[data-jt-atc]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); doAdd(b); });
    });
    var stickyBtn = document.querySelector('[data-jt-sticky-atc]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var mainBtn = box.querySelector('[data-jt-atc]');
      if (mainBtn && !mainBtn.disabled) doAdd(stickyBtn.closest('.jt-sticky') ? mainBtn : mainBtn);
    });

    // sticky bar: hiện khi nút ATC chính RA khỏi khung nhìn (IntersectionObserver, không dùng ngưỡng scroll)
    var sticky = document.querySelector('.jt-sticky');
    var mainAtc = box.querySelector('[data-jt-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var on = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('show', on);
          // đôn cụm nút nổi (bubble Inbox + back-to-top) lên trên thanh ATC dính
          document.body.style.setProperty('--jt-fab-lift', on ? '76px' : '0px');
        });
      }, { threshold: 0 });
      io.observe(mainAtc);
    }

    /* Bubble Inbox nằm trong shadowRoot MỞ của shopify-chat: bơm style ăn theo
       biến --jt-fab-lift (kế thừa xuyên shadow từ body). Chỉ mobile <900 vì
       desktop thanh dính đã display:none dù class show vẫn bật. */
    (function wireChatLift(n) {
      var sc = document.querySelector('shopify-chat');
      if (!sc || !sc.shadowRoot) { if (n < 40) setTimeout(function () { wireChatLift(n + 1); }, 500); return; }
      if (sc.shadowRoot.getElementById('jt-fab-lift')) return;
      var st = document.createElement('style');
      st.id = 'jt-fab-lift';
      st.textContent = '@media (max-width: 899px){.activator-nudge{transform:translateY(calc(-1 * var(--jt-fab-lift, 0px)));transition:transform .35s ease}}';
      sc.shadowRoot.appendChild(st);
    })(0);

    paint();
  }

  /* ---------- quick add trên thẻ sản phẩm (1 variant) ---------- */
  function wireQuickAdd() {
    document.querySelectorAll('[data-jt-qadd]:not([data-jt-wired])').forEach(function (btn) {
      btn.setAttribute('data-jt-wired', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var vid = Number(btn.getAttribute('data-jt-qadd'));
        if (!vid) return;
        btn.disabled = true;
        fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw new Error('fail'); return r.json(); })
          .then(function (json) {
            btn.disabled = false;
            var keys = [];
            if (json && json.items) json.items.forEach(function (x) { if (x.key) keys.push(x.key); });
            if (typeof window.auOpenDrawer === 'function') window.auOpenDrawer(keys);
            else window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart';
          })
          .catch(function () { btn.disabled = false; window.location.href = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart'; });
      });
    });
  }

  /* ---------- PDP reviews: show more ---------- */
  function wireRevMore() {
    document.querySelectorAll('[data-jt-revmore]:not([data-jt-wired])').forEach(function (btn) {
      btn.setAttribute('data-jt-wired', '1');
      btn.addEventListener('click', function () {
        var list = document.querySelector('[data-jt-revlist]');
        if (!list) return;
        var hidden = list.querySelectorAll('.jt-rev.jt-hide');
        Array.prototype.slice.call(hidden, 0, 4).forEach(function (r) { r.classList.remove('jt-hide'); });
        if (list.querySelectorAll('.jt-rev.jt-hide').length === 0) btn.style.display = 'none';
      });
    });
  }

  /* ---------- video/GIF trong thẻ tính năng: chỉ chạy khi lọt vào khung nhìn ----------
     Ba clip cùng chạy nền suốt trang thì tốn pin và băng thông vô ích, nhất là trên
     mobile khi chúng nằm trong dải cuộn ngang và chỉ thấy được một cái. */
  function wireEffVideos() {
    var vids = document.querySelectorAll('.jt-eff-im video:not([data-jt-wired])');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }, { rootMargin: '120px' });
    Array.prototype.forEach.call(vids, function (v) {
      v.setAttribute('data-jt-wired', '1');
      v.pause();
      io.observe(v);
    });
  }

  function init() {
    wireReveal(); wireCounters(); wireRings(); wireHeader(); wireMnav(); wireAcc(); wireEffVideos(); wireGalFit();
    wireQuotes(); wireSort(); wireGallery(); wireBuybox(); wireRevMore(); wireQuickAdd();
    wireMagnet(); wireKbFeedback(); wireKbAcc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
  /* ảnh tải xong mới biết đúng vị trí phần tử, nên đo lại một lượt cho reveal */
  window.addEventListener('load', function () { wireReveal(); wireMagnet(); wireHeader(); });
  setTimeout(init, 1200);
})();




